import React from "react";
import "./about.css";
import profile_picture from "../../assets/profile3.png";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5>Discover More</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={profile_picture} alt="Profile Picture" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>1+ Years in Programming 💻</small>
            </article>
            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>Education</h5>
              <small>B.Tech in IT 🎓 at VNRVJIET</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>21+ Completed 📂</small>
            </article>
          </div>
          <p>
            Hey! I’m Sai Sriram Kamineni. I’m passionate about programming, with a solid foundation in computer science. Over the years, I’ve worked on academic projects, earned certifications, and honed my skills in web development and multiple programming languages.
          </p>
          <p>
            As a B.Tech student at VNR Vignanajyothi Institute of Engineering & Technology, I’ve embraced challenges and grown in both individual and team settings. I’m always eager to learn new things and push my boundaries.
          </p>
          <p>
            Ready to collaborate? Whether it's building innovative solutions or solving real-world problems, I'm excited to contribute. Let’s connect and create something amazing together! 🌟
          </p>
          <a href="#contact" className="btn btn-primary">
            Let’s Collaborate 🤝
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
